import pxToRem from '../../functions/pxToRem';

export default {
    '.apexcharts-tooltip': {
        gap: pxToRem(8),
        lineHeight: pxToRem(16),
        padding: pxToRem(12),

        '.apexcharts-tooltip-series-group': {
            padding: '0 !important',

            '.apexcharts-tooltip-y-group': {
                padding: '0 !important',

                '.apexcharts-tooltip-text-y-value': {
                    fontWeight: 'normal',
                },
            },
        },
    },
};
